
<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">Asset QR Approval</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>

<div class="p-2">
    <form class="example-form">
        <form [formGroup]="assetForm">
            <div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Building Name</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Po No</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text" 
                            formControlName="buildingName" readonly>
                    </div>

                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="poNo" readonly>
                    </div>
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Major Category</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Minor Category</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="majorCategory" readonly>
                   
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="minorCategory" readonly>
                    </div>
                </div>

                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Organization</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Block No</span>
                    </div>
                </div>

                <div class="d-flex  pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="organization" readonly>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="blockNo" readonly>
                    </div>
                </div>
             
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Block Name</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Floor No</span>
                    </div>
                </div>

                <div class="d-flex  pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="blockName" readonly>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="floorNo" readonly>
                    </div>
                </div>
              
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Room Type</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Room No</span>
                    </div>
                </div>

                <div class="d-flex  pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="roomType" readonly>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="roomNo" readonly>
                    </div>
                </div>
                <div class="pt-3">
                    <div class="col-md-6">
                        <span class="image_format">No of Assets</span>
                    </div>
                    <div class="col-md-12 pt-1">
                        <input class="form-control" type="text"  formControlName="noofAssets" readonly>
                    </div>
                </div>
            </div>
        </form>
        <div *ngIf="data.approveStatus!='REJECTED'&&data.approveStatus!='APPROVED'"
            class="text-center d-flex justify-content-center gap-3 pt-3 pb-3">
            <button class="approval_btn" (click)="Approve()">Apporve</button>
            <button class="reject" (click)="reject()">Reject</button>
        </div>
    </form>
</div>

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>